module.exports = __webpack_public_path__ + "img/korokoro_user.e880aef3.png";